module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338628/introduction01_sp-3e4bdde9fa145ad9d78066662aa7ae17.png";